<template>
  <v-lightbox :is-authenticated="true">
    <template v-slot:trigger>
      <div class="flex lg:max-xl:hidden xl:max-2xl:flex 2xl:hidden">
        <a
          @click="show = true"
          class="button button--gray max-lg:!h-[38px] max-lg:!min-h-[38px] max-lg:!w-[38px] max-lg:!p-0 xl:max-2xl:!h-[38px] xl:max-2xl:!min-h-[38px] xl:max-2xl:!w-[38px] xl:max-2xl:!p-0"
        >
            <v-icon icon="trash"></v-icon>
            <span class="hidden lg:inline xl:hidden 2xl:inline">
                <label class="">Izbrišite iskanje</label>
            </span>
        </a>
      </div>
      <div class="hidden lg:max-xl:flex xl:max-2xl:hidden 2xl:flex">
        <a
          @click="show = true"
          class="button button--salmon-hover max-lg:!h-[38px] max-lg:!min-h-[38px] max-lg:!w-[38px] max-lg:!p-0 xl:max-2xl:!h-[38px] xl:max-2xl:!min-h-[38px] xl:max-2xl:!w-[38px] xl:max-2xl:!p-0"
        >
            <v-icon icon="trash"></v-icon>
            <span class="hidden lg:inline xl:hidden 2xl:inline">
                <label class="">Izbrišite iskanje</label>
            </span>
        </a>
      </div>
    </template>
    <template v-slot:head>
      <v-icon icon="trash" class="mr-2.5 text-black-78"></v-icon>
      Izbrišite iskanje
    </template>
    <template v-slot:content>
        <div class="flex flex-col w-full items-center">
            <h2 class="text-black-78 text-icon-text-medium">Kaj se zgodi, če boste izbrisali iskanje?</h2>
            <div class="max-w-md w-full mt-12">
                <div class="flex w-full gap-4 items-center">
                    <div class="flex items-center justify-center rounded-full bg-salmon text-white h-[40px] w-[40px] min-w-[40px] min-h-[40px]">
                        <v-icon icon="article" class="h-[20px] w-[20px]"></v-icon>
                    </div>
                    <p class="text-bold-regular text-black-78 flex-grow">Iz domače strani ne boste več morali uporabljati bližnjice za to iskanje.</p>
                </div>
            </div>
            <div class="max-w-md w-full mt-8 mb-12">
                <div class="flex w-full gap-4 items-center">
                    <div class="flex items-center justify-center rounded-full bg-salmon text-white h-[40px] w-[40px] min-w-[40px] min-h-[40px]">
                        <v-icon icon="envelope" class="h-[20px] w-[20px]"></v-icon>
                    </div>
                    <p class="text-bold-regular text-black-78 flex-grow">Za to te iskalne parametre ne boste več dobivali novih ponudb po elektronski pošti.</p>
                </div>
            </div>
        </div>
    </template>
    <template v-slot:foot>
      <a class="button button--salmon" @click="deleteSearch()" :disabled="loading">
        Želim izbrisati iskanje
        <v-icon icon="trash"></v-icon>
      </a>
    </template>
  </v-lightbox>
</template>

<script>
export default {
  props: {
    searchDeleteRoute: {
      type: String,
      required: true,
    },
    searchCriteriaId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {},
  methods: {
    deleteSearch() {
      let data = {
        search_criteria_id: this.searchCriteriaId,
      };

      this.loading = true;

      let header = {
        headers: {
          "X-CSRF-TOKEN": this.$csrfToken,
        },
      };

      axios.post(this.searchDeleteRoute, data, header).then(
        (response) => {
          location.reload();
        },
        (error) => {
          console.log(error);
        }
      );
    },

  },
};
</script>
